// ======================================================================
// FILE:
// src/modules/wms/reports/components/ExportMenu.jsx
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// Export Menu
// ======================================================================

import React, { useState } from "react";

import reportService from "../services/reportService";

export default function ExportMenu({

    filters,

}) {

    const [loading, setLoading] = useState(false);

    // ==========================================================
    // EXCEL
    // ==========================================================

    async function exportExcel() {

        try {

            setLoading(true);

            const blob =
                await reportService
                    .exportOpenWorkRegisterExcel(
                        filters
                    );

            const url =
                window.URL.createObjectURL(blob);

            const link =
                document.createElement("a");

            link.href = url;

            link.download =
                "Open_Work_Register.xlsx";

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        }

        catch (e) {

            console.error(e);

            alert(
                "Unable to export Excel."
            );

        }

        finally {

            setLoading(false);

        }

    }

    return (

        <button

            className="btn btn-success"

            onClick={exportExcel}

            disabled={loading}

        >

            {

                loading

                    ? "Exporting..."

                    : "Export Excel"

            }

        </button>

    );

}